"use strict";

var _require = require('libphonenumber-js'),
    parsePhoneNumberFromString = _require.parsePhoneNumberFromString;

var d3Format = require('d3-format');

var CLF_MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function pad2(num) {
  var str = String(num);
  return (str.length === 1 ? '0' : '') + str;
}

function clfdate(dateTime) {
  var date = dateTime.getUTCDate();
  var hour = dateTime.getUTCHours();
  var mins = dateTime.getUTCMinutes();
  var secs = dateTime.getUTCSeconds();
  var year = dateTime.getUTCFullYear();
  var month = CLF_MONTH[dateTime.getUTCMonth()];
  return pad2(date) + '/' + month + '/' + year + ':' + pad2(hour) + ':' + pad2(mins) + ':' + pad2(secs) + ' +0000';
}

function formatPhoneNumber(phone) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$country = options.country,
      country = _options$country === void 0 ? 'US' : _options$country;
  var phoneNumber = parsePhoneNumberFromString(phone, country);
  return phoneNumber.formatNational();
}

;

function useSignificantDigits(num) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$digits = _ref.digits,
      digits = _ref$digits === void 0 ? 6 : _ref$digits;

  return Number(d3Format.format(".".concat(digits))(parseFloat(num)));
}

module.exports = {
  pad2: pad2,
  clfdate: clfdate,
  formatPhoneNumber: formatPhoneNumber,
  useSignificantDigits: useSignificantDigits
};